module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/g434ao/tc-custom/9781610587327.jpg?1731055740822",
      "alt": "This image is the cover for the book Zakka Handmades"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Zakka Handmades\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Learn how to sew simple, clever things that organize your home and help with daily tasks with "), _c('i', [_vm._v("Zakka Handmades")]), _vm._v("! These incredibly useful projects include pouches and bags, small toys and baby items, and handy kitchen accessories. Some of the author’s sewn items also incorporate simple crochet. In Japanese, "), _c('i', [_vm._v("zakka")]), _vm._v(" means “household goods,” referring to items for domestic use—tableware, kitchenware, containers of various kinds, even simple clothing. What all the items have in common is a simple, fresh, handmade aesthetic; a subtle, clever wit; and absolute usefulness and practicality.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy Morinaka\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Creative Publishing international, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0